<script setup lang="ts">
const mediaQuery = useMediaQuery()

defineProps<{
  language?: string
}>()
</script>

<template>
  <ion-icon
    :src="
      '/images/flags/' + $t('language.flag', '', { locale: language }) + '.svg'
    "
    class="os-flag"
    :class="{ 'os-flag--compact': !mediaQuery.isLarge }"
  />
</template>

<style>
.os-flag {
  color: #000;
  border-radius: 16px;
  width: 16px;
  height: 16px;
  border: solid 2px white;
  filter: brightness(0.95);
}

.os-flag--compact {
  border-radius: 12px;
  width: 12px;
  height: 12px;
}
</style>
